import React from "react";
import BgImg from "../assests/backgroundImage.avif";
import { Close } from "@mui/icons-material";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import { motion } from "framer-motion";
const Revenue = ({handleClick}) => {


    const theme = useTheme();
    const isBig = useMediaQuery(theme.breakpoints.down(1250));
    const isMobile = useMediaQuery(theme.breakpoints.down(890));
    const isSmall = useMediaQuery(theme.breakpoints.down(380));

    const styles = {
        container: {
            backgroundImage: `url(${BgImg})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            minHeight: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
            color: 'white',
            textAlign: 'center',
            overflow: 'hidden'
        },
        content: {
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            padding: '20px',
            borderRadius: '10px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            boxSizing: 'border-box'
        },
        innerBox: {
            width: isMobile ? '100%' : isBig ? '95%' : '80%',
            backgroundColor: 'rgba(0, 0, 0, 1)',
            padding: isMobile ? '10px' : '20px',
            borderRadius: '15px',
            border: '1px solid #2c2a25',
            boxSizing: 'border-box',
            marginTop: 20
        },
        box: {
            width: isMobile ? '95%' : '23%',
            background: '#fefcf0',
            color: 'black',
            borderRadius: '15px',
            padding: isMobile ? '20px' : isBig ? '30px' : '50px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 20
        },
        iconBox: {
            borderRadius: '50%',
            backgroundColor: 'red',
            width: '40px',
            height: '40px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        icon: {
            fontSize: 30,
            fontWeight: 'bold',
            color: 'white'
        },
        buttonContainer: {
            marginTop: 20,
            textAlign: 'center',
        },
        button: {
            margin: 3,
            borderRadius: '30px',
            color: 'black',
            backgroundColor: 'rgb(255, 210, 48)',
            padding: '15px 60px',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '16px',
            '&:hover': {
                backgroundColor: 'rgb(255, 210, 48)',
                color: '#fff'
            }
        },
    };


    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <div style={{ width: isMobile ? '95%' : isBig ? '80%' : '60%', marginTop: 5}}>
                    <motion.div
                        initial={{ opacity: 0, y: 50, scale: 0.6 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                        viewport={{ amount: 0.5 }}
                        style={{ fontSize: isMobile ? '20px' : '30px', fontWeight: 700, color: '#fff' }}
                    >
                        If you're like many of our eCommerce clients, we don't need to point out just HOW important consistency in revenue is
                    </motion.div>
                </div>

                <div style={styles.innerBox}>
                    <motion.div
                        style={{ marginTop: '40px', fontSize: isMobile ? '15px' : '20px' }}
                        initial={{ opacity: 0, y: 50, scale: 0.6 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                        viewport={{ amount: 0.5 }}
                    >Your brand is worth more than a basic strategies & once in 2 day optimization.
                    </motion.div>
                    <motion.div
                        initial={{ opacity: 0, y: 50, scale: 0.6 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 2, ease: "easeInOut", type: 'spring' }}
                        viewport={{ amount: 0.5 }}
                        style={{ fontSize: isMobile ? '15px' : '20px', marginTop: '10px' }}>
                        Being stuck in an endless cycle of agencies isn't healthy for your brand since:

                    </motion.div>

                    <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'center' : '', justifyContent: isMobile ? 'center' : 'space-evenly', marginTop: 40, gap: 20 }}>
                        <div style={styles.box}>
                            <div style={styles.iconBox}>
                                <Close sx={styles.icon} />
                            </div>

                            <div style={{ fonstSize: '20px', color: 'black', fontWeight: 700, lineHeight: '1.5' }}>
                                Your brand isn't scaling as smoothly as you'd like
                            </div>
                        </div>
                        <div style={styles.box}>
                            <div style={styles.iconBox}>
                                <Close sx={styles.icon} />
                            </div>

                            <div style={{ fonstSize: '20px', color: 'black', fontWeight: 700, lineHeight: '1.5' }}>
                                You're stuck on a certain revenue for a long while now & can't go beyond
                            </div>
                        </div>
                        <div style={styles.box}>
                            <div style={styles.iconBox}>
                                <Close sx={styles.icon} />
                            </div>

                            <div style={{ fonstSize: '20px', color: 'black', fontWeight: 700, lineHeight: '1.5' }}>
                                Your ROAS is constantly dipping & you don't know what's happening
                            </div>
                        </div>
                        <div style={styles.box}>
                            <div style={styles.iconBox}>
                                <Close sx={styles.icon} />
                            </div>

                            <div style={{ fonstSize: '20px', color: 'black', fontWeight: 700, lineHeight: '1.5' }}>
                                Your ROAS is just around Breakeven, you're barely left with anything.
                            </div>
                        </div>


                    </div>
                    <div style={styles.buttonContainer}>
                        <Button sx={styles.button} onClick={handleClick}>Let's Connect</Button>
                    </div>
                </div>

            </div>
        </div >
    );
};


export default Revenue;
